import { put, takeLatest } from 'redux-saga/effects';
import * as Types from '../../actions/types';
import { hideNotification, showNotification } from '../../actions/notification';

function* displayNotification(action) {
  yield put(hideNotification());
  yield put(showNotification(
    action.payload.type,
    action.payload.message,
    action.payload.id
  ));
}

export default function* displayNotificationSaga() {
  yield takeLatest(Types.DISPLAY_NOTIFICATION, displayNotification);
}
